import { render, staticRenderFns } from "./VersionDownloadsRow.vue?vue&type=template&id=42f4bdcb&"
import script from "./VersionDownloadsRow.vue?vue&type=script&lang=js&"
export * from "./VersionDownloadsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports